<template>
  <div class="email-properties">
    <card title="Email Properties" sub-title="Send a shortlist of suitable properties to a prospective buyer.">
      <form @submit.prevent="sendEmail">
        <fieldset class="form-group">
          <label>Buyer Email*</label>
          <input
              type="email"
              class="form-control"
              v-model="email"
              placeholder="user@domain.com"
              required
              ref="emailInput"
            />
        </fieldset>
        <fieldset class="form-group">
          <label>Sender Email*</label>
          <input
              type="email"
              class="form-control"
              v-model="senderEmail"
              placeholder="user@domain.com"
              required
            />
        </fieldset>
        <fieldset class="form-group">
          <label>Personalised Email Message</label>
          <ck-editor v-model="message" height="180px"></ck-editor>
        </fieldset>
        <fieldset class="form-group">
          <label>Property Shortlist</label>
          <label style="font-size: 14px;"><input type="checkbox" v-model="showSoldProperties" @input="selectedProperties = []"> Show sold properties</label>
          <input-multi-select v-model="selectedProperties" :options="propertyOptions" label="Properties"></input-multi-select>
        </fieldset>
        <fieldset class="form-group">
          <label>Sectors Shortlist</label>
          <input-multi-select v-model="selectedSectors" :options="sectorOptions" label="Sectors"></input-multi-select>
        </fieldset>
        <fieldset class="form-group">
          <a :href="favouritesUrl" target="_blank">Shortlist Example Link</a> - Use this link to review property shortlist.
        </fieldset>
        <button class="btn btn-primary mb-3" :disabled="isSubmitting">{{ isSubmitting ? 'Sending...' : 'Send Email' }}</button>
        <transition name="fade">
          <fieldset v-show="isSubmitted" class="form-group">
            <div v-for="message in emailMessages" :key="message" v-html="message"></div>
          </fieldset>
        </transition>
      </form>
    </card>
  </div>
</template>

<script>
import ApiService from '../common/api.service'
import Card from '../components/Cards/Card'
import CkEditor from '../components/CKEditor'
import InputMultiSelect from '../components/InputMultiSelect'
import { mapActions, mapGetters } from 'vuex'
import { FAVOURITES_HOST } from "@/common/config";
export default {
  components: { Card, CkEditor, InputMultiSelect },

  data () {
    return {
      email: '',
      emailMessages: [],
      isSubmitted: false,
      isSubmitting: false,
      message: '',
      selectedProperties: [],
      selectedSectors: [],
      senderEmail: null,
      showSoldProperties: false,
    }
  },

  computed: {
    ...mapGetters([
      'allStructuredProperties',
      'currentUser',
      'livingOptions',
    ]),

    propertyOptions () {
      try {
        let propertyOptions = []
        this.allStructuredProperties.forEach(property => {
          if (this.showSoldProperties || property.status !== 'Sold') {
            propertyOptions.push({ label: `${property.label} - ${property.subsection.displayName.en} - ${property.livingOption.label.en}`, value: property._id })
          }
        })
        return propertyOptions
      } catch (e) {
        console.log(e)
      }
    },

    sectors () {
      return this.livingOptions
    },

    sectorOptions () {
      return this.sectors.map(sector => { return { label: sector.label.en, value: sector._id }})
    },

    favouritesUrl () {
      return `${FAVOURITES_HOST}?r=1&p=${this.selectedProperties}&s=${this.selectedSectors}`
    }
  },

  created () {
    this.$store.dispatch('FETCH_STRUCTURED_PROPERTIES_ALL')
    this.$store.dispatch('FETCH_LIVING_OPTIONS')
  },

  mounted () {
    this.senderEmail = this.currentUser.email
    this.message = `<p>Dear &lt;Customer Name&gt;,</p><p>Thank you for your interest in purchasing a property at Al Mouj Muscat. Please find below a link to view additional information about the property that we discussed today.</p><p>Please get in touch on ${this.currentUser.phone || '[PHONE]'} or ${this.currentUser.email || '[EMAIL]'} if you have any further questions.</p><p>Kind regards,<br />${this.currentUser.name || '[NAME]'}</p>`
    this.$refs.emailInput.focus()
  },

  methods: {
    sendEmail () {
      this.isSubmitting = true
      ApiService.post('favourites/shortlist', {
        email: this.email,
        senderEmail: this.senderEmail,
        propertyIds: this.selectedProperties,
        message: this.message
      })
      .then(() => {
      }).finally(() => {
        this.lastEmail = this.email
        this.isSubmitting = false
        this.isSubmitted = true
        this.emailMessages.push(`Email queued for delivery to <strong>${this.lastEmail}</strong> at ${new Date().toLocaleString()}`)
      })
    }
  }
}
</script>

<style lang="scss">
.email-properties {
  .form-group label{
    // font-weight: 300;
  }

  fieldset {
    margin-bottom: 2em;
  }
}
</style>
